import React from 'react';
import ReactDOM from 'react-dom';

import CircleBackApp from './CircleBackApp';
import './index.css'

ReactDOM.render(<CircleBackApp />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js